import styled from "styled-components";

type Props = {
    children: React.ReactNode,
    title: string,
    titleColor?: boolean
}

export const Statuses = ({ children, title, titleColor = true }: Props) => {

    switch (title) {
        case 'Planejada':
            return <Container style={{ backgroundColor: titleColor ? '#e3f2fd' : 'transparent', color: titleColor ? '#1565c0' : '#1565c0' }}>{children}</Container>
        case 'ExecutadaParcialmente':
            return <Container style={{ backgroundColor: titleColor ? '#fff3e0' : 'transparent', color: '#e65100' }}>{titleColor ? 'Executada Parcialmente' : children}</Container>
        case 'Executada':
            return <Container style={{ backgroundColor: titleColor ? '#e8f5e9' : 'transparent', color: '#2e7d32' }}>{children}</Container>
        case 'Atrasada':
            return <Container style={{ backgroundColor: titleColor ? '#ffebee' : 'transparent', color: '#c62828' }}>{children}</Container>
    }
   
    return (
        <Container>
            {children}
        </Container>
    )
}

export const Container = styled.span`
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    display: inline-block;

    
`;